import React from "react";
import { useDrop } from "react-dnd";
import { useDispatch, useSelector } from "react-redux";
import { useChangeProjectStatusMutation } from "../../features/projects/projectsApi";
import { controlProjectModal } from "../../features/projects/projectSlice";
import WorkCard from "./WorkCard";
export default function Category({ name, quantity, works, plus }) {
  //Dispatcher
  const dispatch = useDispatch();

  //Logged in User
  const { user: loggedInUser } = useSelector((state) => state.auth) || {};

  //Queries
  const [changeProjectStatus] = useChangeProjectStatusMutation();

  const [{ isOver }, drop] = useDrop(() => ({
    accept: "WORK",
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
    drop: (item) => {
      console.log(item);
      changeProjectStatus({
        id: item?.id,
        data: { ...item, status: name, date: new Date().getTime() },
        user: loggedInUser,
      });
    },
  }));

  const bgColor = isOver ? "bg-indigo-300" : "bg-white-200";
  return (
    <div
      className={`flex flex-col flex-shrink-0 w-72 ${bgColor} shadow-md rounded`}
      ref={drop}
    >
      <div className="flex items-center flex-shrink-0 h-10 px-2">
        <span className="block text-sm font-semibold">{name}</span>
        <span className="flex items-center justify-center w-5 h-5 ml-2 text-sm font-semibold text-indigo-500 bg-white rounded bg-opacity-30">
          {quantity}
        </span>
        {plus && (
          <button
            className="flex items-center justify-center w-6 h-6 ml-auto text-indigo-500 rounded hover:bg-indigo-500 hover:text-indigo-100"
            onClick={() => dispatch(controlProjectModal())}
          >
            <svg
              className="w-5 h-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 6v6m0 0v6m0-6h6m-6 0H6"
              />
            </svg>
          </button>
        )}
      </div>
      <div className="flex flex-col pb-2 overflow-auto">
        {works.map((work) => {
          return <WorkCard key={work?.id} work={work} plus={plus} />;
        })}
      </div>
    </div>
  );
}
